export default [
  // {
  //   header: 'Trang chủ',
  // },
  // {
  //   title: 'Dashboards',
  //   route: 'home',
  //   icon: 'HomeIcon',
  // },

  {
    header: 'Quản lí',
  },
  {
    title: 'Người dùng',
    route: 'users',
    icon: 'UserIcon',
  },
  // {
  //   title: 'Giao dịch',
  //   route: 'transaction',
  //   icon: 'CreditCardIcon',
  // },
  {
    title: 'Giao dịch',
    icon: 'CreditCardIcon',
    children: [
      {
        title: 'Nạp tiền',
        unread: "deposit",
        route: 'transaction-deposit',
      },

      {
        title: 'Rút tiền',
        unread: "withdrawal",
        route: 'transaction-withdraw',
      },

      {
        title: 'Đăt cược',
        unread: "order",
        route: 'order',
      },
    ],
  },

  {
    title: 'Trò chơi',
    route: 'games',
    icon: 'BoxIcon',
  },


  {
    title: 'Danh sách trò chơi',
    route: 'products',
    icon: 'BoxIcon',
  },


  {
    title: 'Chat',
    unread: 'chat',
    route: 'chat-manage',
    icon: 'MessageCircleIcon',
  },
  // {
  //   title: 'Cài đặt',
  //   route: 'settings',
  //   icon: 'SettingsIcon',
  // },
]
